module.exports = __webpack_public_path__ + "static/img/cabecera4.d127e640.jpg";